
import { http } from "../http/Http";
import { BrandResponse } from "../models/BrandResponse";

export class BrandService {

    getBrandData = async (url: string): Promise<BrandResponse> => {
        const { data } = await http.get<BrandResponse>("Brand/BrandData?domain=" + url);
        return data;
    };
}